<span class="wrapper">
  <span class="icon" [ngClass]="icon()"></span>
</span>
